import { createSelector } from '@reduxjs/toolkit';
import { selectCurrentVerification } from '../../../data/verificationSlice/selectors';

/**
 * detail-feature derived selectors (hybrid module/feature split): composed from the module-owned
 * base selectors in `data/verificationSlice/selectors`. The module owns the shared aggregate state;
 * the feature owns its own projections. Minimal in Phase 3 (004); grows as editable sections land.
 */
export const selectHasVerification = createSelector(
  selectCurrentVerification,
  (current) => current !== null,
);

/** Latest EVA run outcome (spec 042) — `undefined` before the case loads. */
export const selectEvaDetails = createSelector(
  selectCurrentVerification,
  (current) => current?.evaDetails,
);
